import React, { useEffect, useState } from "react";
import apiClient from "@/api/client";
import { Briefcase, Globe, FileText, LifeBuoy, ChevronRight } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";

export default function PortalDashboard() {
  const [data, setData] = useState(null); const nav = useNavigate();
  useEffect(() => { apiClient.get("/portal/overview").then(r => setData(r.data)); }, []);
  if (!data) return <div className="text-sm text-[#94A3B8]">Yükleniyor…</div>;

  return (
    <div className="space-y-5" data-testid="portal-dashboard">
      <div><h1 className="text-2xl font-bold">Hizmet Özetiniz</h1><p className="text-sm text-[#64748B] mt-1">Aktif hizmetlerinizin durumu</p></div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat icon={Briefcase} label="Aktif Hizmet" value={data.services.filter(s=>s.status==='aktif').length}/>
        <Stat icon={Globe} label="Domain" value={data.domains.length}/>
        <Stat icon={FileText} label="Dosya/Rapor" value={data.files.length}/>
        <Stat icon={LifeBuoy} label="Destek Talebi" value={data.tickets.length}/>
      </div>

      <div className="ky-card">
        <div className="px-5 py-3 border-b border-[#ECECEF] flex items-center justify-between">
          <h3 className="font-semibold text-[15px]">Hizmetleriniz</h3>
        </div>
        <div className="divide-y divide-[#ECECEF]">
          {data.services.length === 0 && <div className="text-center py-12 text-sm text-[#94A3B8]">Henüz hizmet yok.</div>}
          {data.services.map(s => (
            <button key={s.id} onClick={() => nav(`/portal/hizmet/${s.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-[#FAFAFB] text-left transition" data-testid={`portal-service-${s.id}`}>
              <div className="w-10 h-10 rounded-lg bg-[#EEF2FF] text-[#4F46E5] flex items-center justify-center"><Briefcase size={16}/></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2"><span className="font-medium">{s.title}</span><span className={`ky-badge ${s.status==='aktif'?'ky-badge-success':s.status==='tamamlandi'?'ky-badge-neutral':'ky-badge-warning'}`}>{s.status}</span></div>
                <div className="text-xs text-[#64748B] mt-1">{s.service_type} · İlerleme %{s.progress||0}</div>
                <div className="h-1 bg-[#F4F4F5] rounded-full mt-2 overflow-hidden"><div className="h-full bg-[#4F46E5]" style={{ width: `${s.progress||0}%` }}/></div>
              </div>
              <ChevronRight size={16} className="text-[#94A3B8]"/>
            </button>
          ))}
        </div>
      </div>

      {data.tickets.length > 0 && (
        <div className="ky-card">
          <div className="px-5 py-3 border-b border-[#ECECEF] flex items-center justify-between"><h3 className="font-semibold text-[15px]">Son Destek Talepleri</h3><Link to="/portal/destek" className="text-xs text-[#4F46E5] hover:underline">Tümü →</Link></div>
          <div className="divide-y divide-[#ECECEF]">
            {data.tickets.slice(0,5).map(t => (
              <Link key={t.id} to={`/portal/destek/${t.id}`} className="flex items-center gap-3 px-5 py-3 hover:bg-[#FAFAFB]"><span className={`ky-badge ${t.status==='open'?'ky-badge-warning':'ky-badge-neutral'}`}>{t.status}</span><span className="text-sm flex-1 truncate">{t.subject}</span><span className="text-[11px] text-[#94A3B8]">{new Date(t.updated_at).toLocaleDateString("tr-TR")}</span></Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
function Stat({ icon: Icon, label, value }) { return <div className="ky-card p-5"><div className="flex justify-between text-[#64748B]"><span className="text-[11px] font-medium uppercase tracking-wider">{label}</span><Icon size={14}/></div><div className="text-2xl font-semibold tabular-nums mt-2">{value}</div></div>; }
